var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-stats-chart',{attrs:{"fill":"","series":_vm.series,"y-format":_vm.axisFormat,"loading":!_vm.points.length}})
}
var staticRenderFns = []

export { render, staticRenderFns }